export const refundFilterSchemaForFailureReason = [
    {
      id: "pspCode",
      label: "Processors",
      type: "text",
      multiselector: true,
      displayLogo: true,
      items: ["data is updated from api"],
    },
  ];
  